import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof.js";
import "core-js/modules/es6.regexp.split.js";
import _ from 'lodash';
var baseUri = process.env.NODE_ENV === 'development' ? 'http://192.168.178.207:3333' : 'https://' + window.location.hostname;

// get cookie
function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
export default {
  nodeEnv: process.env.NODE_ENV,
  production: process.env.NODE_ENV === 'development',
  baseUri: baseUri,
  storageUri: baseUri + '/storage/',
  selectOptions: function selectOptions(data, value, label) {
    var noBracket = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (_typeof(data) !== 'object') {
      return [];
    }
    var list = [];
    data.forEach(function (obj) {
      if (obj) {
        var objLabel = '';
        if (label.constructor === Array) {
          label.forEach(function (o, index) {
            if (index > 0) {
              objLabel += !noBracket ? ' (' : ' ';
            }
            objLabel += "".concat(_.get(obj, o));
            if (index > 0) {
              objLabel += !noBracket ? ')' : '';
            }
          });
        } else {
          objLabel = _.get(obj, label);
        }
        list.push({
          value: obj[value],
          label: objLabel ? objLabel.trim() : ''
        });
      }
    });
    return list;
  },
  auStates: ['ACT', 'NSW', 'QLD', 'SA', 'NT', 'TAS', 'VIC', 'WA'],
  genders: [{
    label: 'Male',
    value: 'male'
  }, {
    label: 'Female',
    value: 'female'
  }, {
    label: 'Other',
    value: 'other'
  }],
  upload: {
    url: '/api/upload',
    headers: [{
      name: 'X-XSRF-TOKEN',
      value: getCookie('XSRF-TOKEN')
    }],
    images: 'image/jpeg,image/png,image/webp',
    documents: 'image/jpeg,image/png,.pdf,.doc,.docx,.xls,.xlsx,.bat,.mp4,.webp,.csv,.zip,.rar',
    fieldName: 'file'
  },
  tinyMceApiKey: '4k5u1jl55jg5pt5ohrzxkmjup01g8r89lupv3ryxu5ze1g3u',
  tinyMce: {
    plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link' + ' media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern' + ' noneditable help charmap quickbars emoticons image',
    menubar: 'file edit view insert format tools table help dataTokens',
    toolbar: 'undo redo | bold italic underline | dataTokens | fontselect fontsizeselect formatselect | alignleft aligncenter alignright' + ' alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview' + ' save print | insertfile image media template link anchor codesample | ltr rtl',
    themeAdvancedColors: '00aaf1,ff8a00,D85AC4,52B69A,D85A80,5AC1D8,D89E5A,000000',
    textcolor_map: ['000000', 'Black', 'ffffff', 'White', '00aaf1', 'Primary', 'ff8a00', 'Secondary', 'D85AC4', 'Accent', '52B69A', 'Positive', 'D85A80', 'Negative', '5AC1D8', 'Info', 'D89E5A', 'Warning', 'f7f7f7', 'Grey'],
    content_style: '@import' + ' url(\'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap\');body { font-family: \'Source Sans Pro\'; font-size: 11pt; }',
    font_formats: 'Source Sans Pro=Source Sans Pro;Montserrat=Montserrat',
    fontsize_formats: '8pt 10pt 11pt 12pt 14pt 18pt 24pt 36pt',
    tokens: [{
      label: 'Customer Name',
      value: '$customerName'
    }, {
      label: 'Customer Name Abbreviated',
      value: '$cnAbbreviation'
    }, {
      label: 'Customer Address',
      value: '$customerAddress'
    }, {
      label: 'Contact Name',
      value: '$contactName'
    }, {
      label: 'Proposal Name',
      value: '$proposalName'
    }, {
      label: 'Proposal Customer Logo',
      value: '$proposalCustomerLogo'
    }, {
      label: 'Proposal Acceptance Link',
      value: '$proposalAcceptanceLink'
    }, {
      label: 'Author',
      value: '$authorFullName'
    }, {
      label: 'Author Job Title',
      value: '$authorJobTitle'
    }, {
      label: 'Version',
      value: '$version'
    }, {
      label: 'Updated Date',
      value: '$updatedDate'
    }, {
      label: 'Contract Name',
      value: '$contractName'
    }, {
      label: 'Contract Date',
      value: '$contractDate'
    }, {
      label: 'Contract Customer Logo',
      value: '$contractCustomerLogo'
    }, {
      label: 'Products Upfront List',
      value: '$products_upfront'
    }, {
      label: 'Products Upfront Total',
      value: '$products_upfront_total'
    }, {
      label: 'Products Recurring List',
      value: '$products_recurring'
    }, {
      label: 'Products Recurring Total',
      value: '$products_recurring_total'
    }, {
      label: 'Products - CyberSecurity Essentials List',
      value: '$products_group_cyber'
    }, {
      label: 'Products - CyberSecurity Essentials Total',
      value: '$products_group_cyber_total'
    }, {
      label: 'Products - Microsoft 365 Licensing List',
      value: '$products_group_365_licensing'
    }, {
      label: 'Products - Microsoft 365 Licensing Total',
      value: '$products_group_365_licensing_total'
    }, {
      label: 'Products - Password Manager List',
      value: '$products_group_password_manager'
    }, {
      label: 'Products - Password Manager Total',
      value: '$products_group_password_manager_total'
    }, {
      label: 'Products - Backups List',
      value: '$products_group_backups'
    }, {
      label: 'Products - Backups Total',
      value: '$products_group_backups_total'
    }, {
      label: 'Products - Spam Filtering List',
      value: '$products_group_spam_filtering'
    }, {
      label: 'Products - Spam Filtering Total',
      value: '$products_group_spam_filtering_total'
    }, {
      label: 'Products - DNS Filtering List',
      value: '$products_group_dns_filtering'
    }, {
      label: 'Products - DNS Filtering Total',
      value: '$products_group_dns_filtering_total'
    }, {
      label: 'Products - Patching List',
      value: '$products_group_patching'
    }, {
      label: 'Products - Patching Total',
      value: '$products_group_patching_total'
    }, {
      label: 'Products - EDR List',
      value: '$products_group_edr'
    }, {
      label: 'Products - EDR Total',
      value: '$products_group_edr_total'
    }, {
      label: 'Products - Internet List',
      value: '$products_group_internet'
    }, {
      label: 'Products - Internet Total',
      value: '$products_group_internet_total'
    }, {
      label: 'Products - VOIP List',
      value: '$products_group_voip'
    }, {
      label: 'Products - VOIP Total',
      value: '$products_group_voip_total'
    }, {
      label: 'Products - Support Services List',
      value: '$products_group_support_services'
    }, {
      label: 'Products - Support Services Total',
      value: '$products_group_support_services_total'
    }, {
      label: 'Products Grand Total',
      value: '$products_grand_total'
    }]
  }
};